<template>
  <card-dashboard class="external-link">
    <div class="flex items-center justify-between mb-7">
      <div class="md-title font-bold text-xl">
        {{ $t("dashboard.learning_corner") }}
      </div>
      <div
        class="external-link-icon-header w-[32px] h-[32px] flex items-center justify-center bg-white"
      >
        <i class="fas fa-link text-[#7ca4ff]"></i>
      </div>
    </div>
    <div class="flex justify-start flex-wrap external-link-content">
      <a href="https://igs.agilixbuzz.com/" target="_blank">
        <div class="icon-item">
          <img
            src="/img/dashboard/flvs-logo.png"
            alt="Florida Virtual School image"
            class="w-[65%] h-[65%]"
          />
        </div>
        <md-tooltip md-direction="top">Florida Virtual School</md-tooltip>
      </a>
      <a href="https://auth.edmentum.com/" target="_blank">
        <div class="icon-item">
          <img src="/img/dashboard/edmentum.png" alt="Edmentum image" />
        </div>
        <md-tooltip md-direction="top">Edmentum</md-tooltip>
      </a>
      <a href="https://online-signin.megaschool.edu.vn/" target="_blank">
        <div class="icon-item">
          <img src="/img/dashboard/mega-school.png" alt="MegaSchool image" />
        </div>
        <md-tooltip md-direction="top">MegaSchool</md-tooltip>
      </a>
      <a href="https://www.getepic.com/sign-in/educator/" target="_blank">
        <div class="icon-item">
          <img src="/img/dashboard/epic.png" alt="Epic image" />
        </div>
        <md-tooltip md-direction="top">Epic</md-tooltip>
      </a>
      <a href="https://studenthub.ivyglobalschool.org/" target="_blank">
        <div class="icon-item">
          <span class="text-center text-[12px] text-[#2d82b5] font-bold">
            IGS Student <br />
            Hub
          </span>
        </div>
        <md-tooltip md-direction="top">IGS Student Hub</md-tooltip>
      </a>
      <a href="https://english-dashboard.pearson.com/session" target="_blank">
        <div class="icon-item">
          <span class="text-center text-[12px] text-[#2d82b5] font-bold">
            IGS Prep <br />
            E-book
          </span>
        </div>
        <md-tooltip md-direction="top">IGS Prep E-book</md-tooltip>
      </a>

      <!-- IGS_LMS -->
      <a v-for="ext in externals" :key="ext.alt"
        :href="ext.url" target="_blank">
        <div class="icon-item">
          <img :src="ext.icon" :alt="ext.alt" />
        </div>
        <md-tooltip md-direction="top">{{ext.label}}</md-tooltip>
      </a>
    </div>
  </card-dashboard>
</template>

<script>
import CardDashboard from "./CardDashboard";
export default {
  name: "external-link",
  components: { CardDashboard },
  data(){
    return {
      externals: [
        {
          url: process.env.VUE_APP_CMS_DOMAIN,
          icon: "/img/dashboard/igs_cms.png",
          alt: "CMS Image",
          label: "IGS CMS"
        },
        {
          url: process.env.VUE_APP_LCMS_DOMAIN,
          icon: "/img/dashboard/igs_lcms.png",
          alt: "LCMS Image",
          label: "IGS LCMS"
        },
        {
          url: process.env.VUE_APP_STUDENT_WEB_DOMAIN,
          icon: "/img/dashboard/igs_student.png",
          alt: "Student Web Image",
          label: "IGS Student  Web"
        },
        {
          url: process.env.VUE_APP_TEACHER_PORTAL_DOMAIN,
          icon: "/img/dashboard/igs_teacher.png",
          alt: "Teacher Portal Image",
          label: "IGS Teacher Portal"
        },
      ]
    }
  }
};
</script>

<style lang="scss">
.external-link {
  &-icon-header {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
  }
  &-content {
    a {
      margin: 10px;
    }
    a:hover,
    a:active {
      .icon-item {
        border: 1px solid #a3c0fb;
      }
    }
  }
  .icon-item {
    width: 100px;
    aspect-ratio: 1/1; // ~ width/height
    padding: 0 5px;
    background-color: #f4f7fe;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
